var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"main"},[(!_vm.hasErr)?_c(_vm.moduleId,{tag:"component",attrs:{"info":_vm.enterInfo,"stepNo":_vm.stepNo}}):_c('empty',{attrs:{"text":"系统异常"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }